import { render, staticRenderFns } from "./ContestOverviewView.vue?vue&type=template&id=6cd61fde&scoped=true&"
import script from "./ContestOverviewView.vue?vue&type=script&lang=js&"
export * from "./ContestOverviewView.vue?vue&type=script&lang=js&"
import style0 from "./ContestOverviewView.vue?vue&type=style&index=0&id=6cd61fde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd61fde",
  null
  
)

export default component.exports